import { render } from "./CriarConta.vue?vue&type=template&id=de8daf94"
import script from "./CriarConta.vue?vue&type=script&lang=js"
export * from "./CriarConta.vue?vue&type=script&lang=js"

import "./CriarConta.vue?vue&type=style&index=0&id=de8daf94&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__